import dayjs from 'dayjs';

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

/** Parse YYYY-MM-DD as a local calendar day, not UTC midnight. */
export function parseAttendanceDate(dateString: string): Date {
  const match = DATE_ONLY.exec(dateString);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  return new Date(dateString);
}

export function formatAttendanceDate(dateString: string): string {
  return dayjs(parseAttendanceDate(dateString)).format('MMM DD, YYYY');
}

export function parentGuardianLabels(record: {
  parentName: string;
  signInActorName?: string | null;
  signOutActorName?: string | null;
}): string[] {
  const lines: string[] = [];
  if (record.signInActorName) {
    lines.push(`Sign in: ${record.signInActorName}`);
  }
  if (record.signOutActorName) {
    lines.push(`Sign out: ${record.signOutActorName}`);
  }
  if (lines.length === 0) {
    lines.push(record.parentName);
  }
  return lines;
}
